import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'

import CServicosHospitalares from './CServicosHospitalares/index.vue'

library.add(faFilePdf)

@Component({
	components: {
		Loader,
		CServicosHospitalares,
	},
})
export default class HotSite extends Vue {}
